import '../App.css'
function MainBody() {
    return (
        <div style={{ textAlign: "center", marginBottom: "30px" }}>
            <h1 style={{
                fontSize: "40px",
                fontFamily: 'Tenada',
                color: "#FF6347",
                textShadow: "2px 2px #FFD700"
            }}>
                Chill Guy Meme Generator
            </h1>
            <img
                src="/chillguy.png"
                alt="Chill Guy"
                style={{
                    borderRadius: '10px',
                    marginTop: "20px",
                    maxWidth: "70%",
                }}
            />
        </div>
    );
}

export default MainBody;
